// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5bb7c756","239":"20f557a8","455":"d2f21614","488":"4a66190e"}[chunkId] + ".chunk.js";
};